import React, { useState, useEffect, useContext, useCallback } from 'react';
import "./PageDesign/Styles/NavBar.css";
import { useNavigate } from 'react-router-dom';

function NavBar() {
  const Navigate = useNavigate();

  const [LowerBlock, setLowerBlock] = useState(window.innerWidth <= 950 ? true : false);
  const [BurgerMenu, setBurgerMenu] = useState(false);
  const [BurgerSpecific, setBurgerSpecific] = useState(window.innerWidth <= 950 ? true : false);
  const [PlusScroll, setPlusScroll] = useState(window.innerWidth <= 520 ? 1000 : window.innerWidth <= 847 ? 500 : 0);

  function ToggleNavbarDisplay() {
    let x = document.getElementById("NavbarBurgerIcon")
    x.classList.toggle("change");
    if(BurgerMenu) {
      setBurgerMenu(false)
    } else {
      setBurgerMenu(true)
    }
  }

  function ToggleProfileMenu() {
    let x = document.getElementById("ProfileMenu")
    if(x.className.includes("NavbarFullInnerRightSideProfileButtonMenuHidden")) {
      x.className = x.className.replace(" NavbarFullInnerRightSideProfileButtonMenuHidden","")
    } else {
      x.className += " NavbarFullInnerRightSideProfileButtonMenuHidden"
    }
  }

  const HandleLowerBlock = useCallback(() => {
    if(window.innerWidth <= 950) {
      setLowerBlock(true)
      setBurgerSpecific(true)
    } else {
      setLowerBlock(false)
      setBurgerSpecific(false)
      setBurgerMenu(false)
    }

    if(window.innerWidth <= 540) {
      let x = document.getElementById("ProfileMenu")
      if(x && !x.className.includes("NavbarFullInnerRightSideProfileButtonMenuHidden") && !BurgerSpecific) {
        x.className += " NavbarFullInnerRightSideProfileButtonMenuHidden"
      }
    }

    if(window.innerWidth <= 520) {
      setPlusScroll(1000)
    } else if(window.innerWidth <= 847) {
      setPlusScroll(500)
    } else { 
      setPlusScroll(0)
    }
  },[BurgerSpecific])

  const hideUpperBar = useCallback(() => {
    let currentScrollPos = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    if (!currentScrollPos) {
      document.getElementById("navbar").style.top = "0";
    } else {
      document.getElementById("navbar").style.top = "-30px";
    }
  },[])

  function numberWithCommas(x) {
    var parts = x.toString().split(".");
    parts[0]=parts[0].replace(/\B(?=(\d{3})+(?!\d))/g,".");
    return parts.join(",");
  }

  useEffect(() => {
    window.addEventListener("resize", HandleLowerBlock);
    return () => window.removeEventListener("resize", HandleLowerBlock);
  }, [HandleLowerBlock]);

  useEffect(() => {
    window.addEventListener("scroll", hideUpperBar);
    return () => window.removeEventListener("scroll", hideUpperBar);
  }, [hideUpperBar]);

  return (
    <div className='NavbarFull' id="navbar">
      <div className='NavbarPurpleUpBar'>
        <div className='NavbarPurpleUpBarInner'>
          <div className='NavbarPurpleUpBarInnerButton NavInnerSelected' onClick={() => Navigate("/")}>Empresas</div>
          <div className='NavbarPurpleUpBarInnerButton'><a href='https://www.yomecontrolo.cl' target="_blank" rel="noreferrer" style={{textDecoration:"none",color:"white"}}>APS - Personas</a></div>
          <div className='NavbarPurpleUpBarInnerSocial'>
            <a href='https://www.instagram.com/yomecontrolo/' target="_blank" className="SocialIcon" rel="mainWebsite">
              <img src="https://static.yomecontrolo.cl/public/icons/social-instagram.png" alt="Instagram Icon" height={25} />
            </a>
            <a href='https://cl.linkedin.com/company/yomecontrolo' target="_blank" className="SocialIcon" rel="mainWebsite">
              <img src="https://static.yomecontrolo.cl/public/icons/social-linkedin.png" alt="LinkedIn Icon" height={22} />
            </a>
          </div>
        </div>
      </div>
      <div className="NavbarFullOuter">
        <div className={LowerBlock && BurgerMenu ? "NavbarFullInner NavbarMenuOpen" : "NavbarFullInner"}>
          <div className="NavbarFullInnerLeftSide">
            <img src="https://static.yomecontrolo.cl/public/companies/NavbarLogo.png" className="NavbarFullInnerLeftSideLogoYMC" alt="logo" onClick={() => {document.body.scrollTop = 0; document.documentElement.scrollTop = 0; Navigate("/")}} />
          </div>
            {BurgerSpecific ?
            <div className="NavbarFullInnerRightSide">
              <div className="NavbarFullInnerRightSideBurgerIcon" id="NavbarBurgerIcon" onClick={() => ToggleNavbarDisplay()}>
                <div className="NavbarBurgerIconBar3"></div>
                <div className="NavbarBurgerIconBar1"></div>
                <div className="NavbarBurgerIconBar2"></div>
              </div>
            </div>
            : 
            <div className="NavbarFullInnerMiddleButtons">
              <div className='NavbarFullInnerMiddleIndividualButton' onClick={() => {document.body.scrollTop = 0; document.documentElement.scrollTop = 0; }}>Programas</div>
              <div className='NavbarFullInnerMiddleIndividualButton' onClick={() => {document.body.scrollTop = 800; document.documentElement.scrollTop = 800; }}>Beneficios</div>
              <div className='NavbarFullInnerMiddleIndividualButton' onClick={() => {document.body.scrollTop = 1750+PlusScroll; document.documentElement.scrollTop = 1750+PlusScroll; }}>Servicios</div>
              <div className='NavbarFullInnerMiddleIndividualButton' onClick={() => {document.body.scrollTop = 3500+PlusScroll; document.documentElement.scrollTop = 3500+PlusScroll; }}>Importancia</div>
              <div className='NavbarFullInnerMiddleIndividualButton' onClick={() => {document.body.scrollTop = 4300+PlusScroll; document.documentElement.scrollTop = 4300+PlusScroll; }}>Contacto</div>
            </div>
            }
          </div>
      </div>
      {LowerBlock && BurgerMenu ?
      <div className="NavbarLowerBlockOptions">
        <div className="NavbarLowerBlockOptionsWhiteBox">
          {!document.URL.includes("encuesta-bienvenida") ?
          <>
          <div className='NavbarLowerBlockOptionsIndividualButton' onClick={() => {document.body.scrollTop = 0; document.documentElement.scrollTop = 0; ToggleNavbarDisplay() }}>Programas</div>
          <div className='NavbarLowerBlockOptionsIndividualButton' onClick={() => {document.body.scrollTop = 850; document.documentElement.scrollTop = 850; ToggleNavbarDisplay() }}>Beneficios</div>
          <div className='NavbarLowerBlockOptionsIndividualButton' onClick={() => {document.body.scrollTop = 1700+PlusScroll; document.documentElement.scrollTop = 1700+PlusScroll; ToggleNavbarDisplay() }}>Servicios</div>
          <div className='NavbarLowerBlockOptionsIndividualButton' onClick={() => {document.body.scrollTop = 3500+PlusScroll*3; document.documentElement.scrollTop = 3500+PlusScroll*3; ToggleNavbarDisplay() }}>Importancia</div>
          <div className='NavbarLowerBlockOptionsIndividualButton' onClick={() => {document.body.scrollTop = 4300+PlusScroll*3; document.documentElement.scrollTop = 4300+PlusScroll*3; ToggleNavbarDisplay()}}>Contacto</div>
          </>
          : null}
        </div>
      </div>
      : null }
      </div>
  );
}

export default NavBar;